<template>
  <div class="history">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <history-component active-name="MY_ATTEND" />
    <van-dialog
      v-model="showInviteCodeDialog"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      title="邀请码"
      class="bigHeight"
    >
      <p class="diaCode">{{ inviteCode }}</p>
      <div class="tips">
        <p>温馨提示</p>
        <p>1、邀请码仅来访当天有效，请勿泄露</p>
        <p>2、来访请先到前台出示身份证及邀请码验证身份</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import historyComponent from './historyComponent'
import config from '@/common/config'
import { GetVisitorAppoinDetail } from '@/api/user'
export default {
  name: 'History',
  components: {
    historyComponent
  },
  data() {
    return {
      baseURL:
        process.env.NODE_ENV === 'development'
          ? config.baseUrl.dev
          : config.baseUrl.pro,
      subHead: '会议记录',
      size: 10,
      visitorAppointList: [],
      showQrCodeDialog: false,
      showInviteCodeDialog: false,
      inviteCode: '', // 邀请码
      hisId: '', // 历史记录id，刷新二维码用,
      nowStatus: '', // 状态。从消息进来根据状态判断是二维码还是详情
      qrcode: '', // 因为路由参数的qrcode带#h号，被干掉了，所以从详情拿qrcode
      historyDetail: {},
      timestamp: new Date().getTime(),
      qrCodeImgUrl: '' // 二维码图片
    }
  },
  watch: {
    historyDetail: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          if (this.nowStatus === 'VISITING' || this.nowStatus === 'WAITING_VISIT') {
            this.showQrCodeDialog = true
            this.$nextTick(() => {
              this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.qrcode)}&timestamp=${this.timestamp}`
            })
          } else {
            this.$router.push({ name: 'historyDetail', query: { id: this.hisId, activeName: this.activeName }})
          }
        })
      }
    }
  },
  created() {
    // 从消息模板进来
    if (this.$route.query.qrcode && this.$route.path === '/history') {
      this.hisId = this.$route.query.id
      this.getVisitorAppoinDetail(this.hisId)
    }

    if (this.$route.query.askCode && this.$route.path === '/history') {
      this.showInviteCodeDialog = true
      this.inviteCode = this.$route.query.askCode
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'user' });
    },
    // 预约记录详情
    getVisitorAppoinDetail(id) {
      const data = {
        id: id
      }
      GetVisitorAppoinDetail(data).then(response => {
        this.historyDetail = response.data
        this.nowStatus = this.historyDetail.visitorStatus
        this.qrcode = this.historyDetail.qrCode
      })
    }
  }

}
</script>

<style lang="less" scoped>
.history {
  .qrcode {
    // width: 1.64rem;
    // height: 1.64rem;
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    /deep/img {
      width: 1.64rem !important;
      height: 1.64rem;
    }
  }
  .diaCode {
    color: #333;
    text-align: center;
    font-size: 0.3rem;
    line-height: 0.3rem;
    height: 0.3rem;
    margin-bottom: 0.2rem;
  }
  .van-button {
    display: flex;
    width: 0.95rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    margin: 0.25rem auto;
  }
  .tips {
    font-size: 0.12rem;
    color: #ffbe00;
    line-height: 0.18rem;
  }
}
</style>
